import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';

type Props = {
  title: string;
  content?: string | React.ReactNode;
  preview: React.ReactNode;
};
function BuildStep(props: Props) {
  const { title, content, preview } = props;

  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{ display: 'flex', flexDirection: isSmall ? 'column' : 'row', py: 4 }}
    >
      <Box sx={{ flex: '1', pb: 4, pr: 10, maxWidth: 600 }}>
        <Typography variant="h5">{title}</Typography>
        {typeof content === 'string' ? (
          <Typography>{content}</Typography>
        ) : (
          content
        )}
      </Box>

      <Box component="div">{preview}</Box>
    </Box>
  );
}

export default BuildStep;
